module.exports = __webpack_public_path__ + "img/GAME_GETTHENUMBERDISH.ab4fa433.png";